// AUTO-GENERATED at build time by scripts/write-version.js — do not edit
export const BUILD_INFO = {
  "commit": "a57b3c0c72b0969b4d21f61003bbfae8a5cf0dc3",
  "commitShort": "a57b3c0",
  "commitDate": "2026-10-08T06:07:21+00:00",
  "branch": "main",
  "buildTime": "2026-10-09T22:54:01.277Z"
};
